import { render, staticRenderFns } from "./branch-card-detail-horizontal.vue?vue&type=template&id=3f3c376a&scoped=true"
import script from "./branch-card-detail-horizontal.vue?vue&type=script&lang=js"
export * from "./branch-card-detail-horizontal.vue?vue&type=script&lang=js"
import style0 from "./branch-card-detail-horizontal.vue?vue&type=style&index=0&id=3f3c376a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c376a",
  null
  
)

export default component.exports